export const EnvironmentTypes = {
  dev: "DEV",
  test: "TEST",
  prod: "PROD",
};
//koda göre değişir 
//const sabit veriler